<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <el-dialog
    title="批量导入事故信息"
    :visible.sync="visible"
    :before-close="closeModal"
  >
  <!-- eslint-enable -->
    <div class="modal-inner-box">
      <div class="tips-area mt-24">
        <p>导入说明：</p>
        <p class="mt-16">1、点击“下载模板”，并使用模板Excel进行数据填写。</p>
        <p>2、确保填写字段信息与模板中标题保持一致，模板Excel中带有“*”标识的信息为必填项。</p>
        <p>3、点击“导入数据”完成数据上传。</p>
      </div>
      <div class="operating-area mt-48">
        <div class="btns-area">
          <el-upload
            action=""
            accept=".xls,.xlsx"
            :fileList="upload.fileList"
            :limit="1"
            :http-request="uploadRequest"
            :auto-upload="true"
            :show-file-list="false"
          >
            <el-button :loading="upload.loading" type="primary">导入数据</el-button>
          </el-upload>
          <el-button class="ml-16" type="text" @click="handleDownloadTemplate">下载导入模板</el-button>
          <el-button class="ml-16" type="text" @click="getUploadTaskDetail" v-if="upload.fileList.length">查看导入进度</el-button>
        </div>
        <div v-if="upload.fileList.length" class="progress-area mt-16">
          <p>{{upload.fileList[0].name}}</p>
          <p class="ml-16"><i class="icon QS-icon-loading" v-if="upload.loading" />{{upload.status}}</p>
          <i class="ml-8 el-icon-delete" @click="resetModal"></i>
        </div>

      </div>
    </div>
  </el-dialog>
</template>
<script>
import { uploadFile } from '@/api/domain/returnLease'
import { batchImportAccidentTemplate } from '@/config'
import { uploadTaskCreate } from '@/api/domain/others'

export default {
  props: ['visible'],
  data() {
    return {
      upload: {
        fileList: [],
        loading: false,
        status: '',
      },
    }
  },
  methods: {
    async uploadRequest({ file }) {
      this.upload.loading = true
      this.upload.status = '上传中'
      this.upload.fileList = [file]
      const formData = new FormData()
      formData.append('file', file)
      formData.append('group', 'vehicle')
      formData.append('code', 'vehicle_accident_file')

      const { code, data } = await uploadFile(formData)
      if (code !== 1) {
        this.upload.loading = false
        this.upload.status = '上传失败'
        return
      }
      this.upload.status = '上传成功'
      await this.uploadTask(data, file.name)
    },
    async uploadTask(url, fileName) {
      const para = { uploadType: 63, fileAddress: url, fileName }
      this.upload.status = '导入中'
      // 63: 事故信息批量导入
      const { code } = await uploadTaskCreate(para)
      this.upload.loading = false
      if (code !== 1) {
        this.upload.status = '导入失败'
        return
      }
      this.upload.status = '导入成功'

      this.$message.success('数据已上传成功，点击“查看导入进度” 查看任务导入进度')
    },
    closeModal() {
      this.$emit('closed')
      this.resetModal()
    },
    resetModal() {
      this.upload.fileList = []
      this.upload.status = ''
      this.upload.loading = false
    },
    handleDownloadTemplate() {
      window.location.href = batchImportAccidentTemplate
    },
    getUploadTaskDetail() {
      this.closeModal()
      this.$router.push('/logCenter/importAccidentLog/list')
    },
  },

}

</script>
<style lang="scss" scoped>
  ::v-deep .el-icon-delete:hover {
    color: #409EFF;
  }
  .modal-inner-box {
    padding: 16px;
    .el-icon-delete {
      cursor: pointer;
    }
    .mr-8 {
      margin-right: 8px;
    }
    .ml-8 {
      margin-left: 8px;
    }
    .ml-16 {
      margin-left: 16px;
    }
    .ml-16 {
      margin-left: 16px;
    }
    .mt-16 {
      margin-top: 16px;
    }
    .mt-48 {
      margin-top: 48px;
    }
    .btns-area {
      display: flex;
    }
    .progress-area {
      display: flex;
      align-items: center;
    }
  }
</style>
